module.exports = __webpack_public_path__ + "img/influencer-icon.132fc398.svg";